export const LIMPIA_CAJA = "LIMPIA_CAJA"
export const TOAST_MSJ = "TOAST_MSJ";
export const LOG_USER = "LOG_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SEND_USER_MSJ = "SEND_USER_MSJ";
export const TOKEN_VENCIDO = "TOKEN_VENCIDO";
export const CHK_USER = "CHK_USER";

export const GET_ENQUIRIES = "GET_ENQUIRIES";
export const GET_ROOMS = "GET_ROOMS";
export const GET_ROOMS_PRICES = "GET_ROOMS_PRICES";
export const GET_SEASONS = "GET_SEASONS";
export const UPDATE_SEASONS = "UPDATE_SEASONS";
export const GET_CUSTOM_ITEMS = "GET_CUSTOM_ITEMS";

export const SET_CONTAINI = "SET_CONTAINI"
export const GET_CONTAINI = "GET_CONTAINI"
export const GET_DESTINATARIOS = "GET_DESTINATARIOS"
export const GET_CASHBOOK = "GET_CASHBOOK"

export const GET_INVENTARY = "GET_INVENTARY";
export const GET_CLIENTS = "GET_CLIENTS";
export const GET_SUPPLIERS = "GET_SUPPLIERS";
export const GET_ITEMS = "GET_ITEMS";
export const GET_USUARIOS = "GET_USUARIOS";
export const GET_MEDIOS = "GET_MEDIOS";
export const GET_MONEDAS = "GET_MONEDAS";
export const GET_RUBROS = "GET_RUBROS";
export const GET_SUBRUBROS = "GET_SUBRUBROS";
export const GET_SOURCE = "GET_SOURCE";
export const GET_CUERPO = "GET_CUERPO";
export const GET_TAXES = "GET_TAXES";

export const ADD_MOV = "ADD_MOV";
export const ADD_CLIENT = "ADD_CLIENT";
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const ADD_ITEM = "ADD_ITEM";
export const ADD_USUARIO = "ADD_USUARIO";
export const ADD_MEDIO = "ADD_MEDIO";
export const ADD_MONEDA = "ADD_MONEDA";
export const ADD_RUBRO = "ADD_RUBRO";
export const ADD_SUBRUBRO = "ADD_SUBRUBRO";
export const ADD_SOURCE = "ADD_SOURCE";
export const ADD_TAX = "ADD_TAX";
export const UPDATE_MOV = "UPDATE_MOV";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const UPDATE_USUARIO = "UPDATE_USUARIO";
export const UPDATE_MEDIO = "UPDATE_MEDIO";
export const UPDATE_MONEDA = "UPDATE_MONEDA";
export const UPDATE_RUBRO = "UPDATE_RUBRO";
export const UPDATE_SUBRUBRO = "UPDATE_SUBRUBRO";
export const UPDATE_SOURCE = "UPDATE_SOURCE";
export const UPDATE_TAX = "UPDATE_TAX";
export const ADD_MOV_ITEM = "ADD_MOV_ITEM";
export const ADD_MOV_PAGO = "ADD_MOV_PAGO";
export const UPDATE_MOV_ITEM = "UPDATE_MOV_ITEM";
export const UPDATE_MOV_PAGO = "UPDATE_MOV_PAGO";
export const DEL_MOV_ITEM = "DEL_MOV_ITEM";
export const DEL_MOV_PAGO = "DEL_MOV_PAGO";

export const DEL_MOV = "DEL_MOV";
export const DEL_CLIENT = "DEL_CLIENT";
export const DEL_SUPPLIER = "DEL_SUPPLIER";
export const DEL_ITEM = "DEL_ITEM";
export const DEL_MEDIO = "DEL_MEDIO";
export const DEL_MONEDA = "DEL_MONEDA";
export const DEL_RUBRO = "DEL_RUBRO";
export const DEL_SUBRUBRO = "DEL_SUBRUBRO";
export const DEL_SOURCE = "DEL_SOURCE";
export const DEL_TAX = "DEL_TAX";
export const ADD_STOCK = "ADD_STOCK";
export const GET_STOCK = "GET_STOCK";
export const GET_CAJA = "GET_CAJA";
export const GET_CAJA_MOVS = "GET_CAJA_MOVS";
export const UPDATE_DATO = "UPDATE_DATO";
export const UPDATE_PRICE = "UPDATE_PRICE";
export const CAMBIA_HOTEL_DEF = "CAMBIA_HOTEL_DEF";
export const GET_HOTELES = "GET_HOTELES";
export const GET_INFORME = "GET_INFORME";
export const GET_COMISIONES = "GET_COMISIONES";

export const GET_CALENDARIO = 'GET_CALENDARIO'
export const GET_EVENTOS = 'GET_EVENTOS'
export const ADD_EVENTO = 'ADD_EVENTO'
export const UPDATE_EVENTO = 'UPDATE_EVENTO'
export const DEL_EVENTO = 'DEL_EVENTO'
export const ADD_PARTICIPANTE = 'ADD_PARTICIPANTE'
export const UPDATE_PARTICIPANTE = 'UPDATE_PARTICIPANTE'
export const DEL_PARTICIPANTE = 'DEL_PARTICIPANTE'

export const GET_DASHINI ="GET_DASHINI"
export const GET_MEAN_PAYMENTS ="GET_MEAN_PAYMENTS"
export const GET_RESUMEN ="GET_RESUMEN"

export const GET_ACTIVITY_FORMATS="GET_ACTIVITY_FORMATS"
export const ADD_ACTIVITY_FORMATS="ADD_ACTIVITY_FORMATS"
export const UPDATE_ACTIVITY_FORMATS="UPDATE_ACTIVITY_FORMATS"
export const DEL_ACTIVITY_FORMATS="DEL_ACTIVITY_FORMATS"

export const GET_ACTIVITIES="GET_ACTIVITIES"
export const ADD_ACTIVITIES="ADD_ACTIVITIES"
export const UPDATE_ACTIVITIES="UPDATE_ACTIVITIES"
export const DEL_ACTIVITIES="DEL_ACTIVITIES"

export const GET_INSTRUCTORS="GET_INSTRUCTORS"
export const ADD_INSTRUCTORS="ADD_INSTRUCTORS"
export const UPDATE_INSTRUCTORS="UPDATE_INSTRUCTORS"
export const DEL_INSTRUCTORS="DEL_INSTRUCTORS"

export const GET_ASSET="GET_ASSET"
export const ADD_ASSET="ADD_ASSET"
export const UPDATE_ASSET="UPDATE_ASSET"
export const DEL_ASSET="DEL_ASSET"

export const GET_ASSETS_TYPE="GET_ASSETS_TYPE"
export const ADD_ASSETS_TYPE="ADD_ASSETS_TYPE"
export const UPDATE_ASSETS_TYPE="UPDATE_ASSETS_TYPE"
export const DEL_ASSETS_TYPE="DEL_ASSETS_TYPE"

export const GET_BNUMBERS="GET_BNUMBERS"
export const ADD_BNUMBERS="ADD_BNUMBERS"
export const UPDATE_BNUMBERS="UPDATE_BNUMBERS"

export const GET_RECEIPTS = "GET_RECEIPTS"

export const GET_YOGA = "GET_YOGA"
export const GET_HISTORIAL_CAJA = "GET_HISTORIAL_CAJA"
export const CHECK_CABECERA = "CHECK_CABECERA"
export const CHECK_ITEM = "CHECK_ITEM"
export const GET_ENQUI_REPORT = "GET_ENQUI_REPORT"